import cookieModel from './cookieModel';
import authModel from './authModel';
import apiErrorModel from './apiErrorModel';
import getBaseUrl from '../utils/baseUrl';

const LOGIN_URLS = ['/login', '/login/staff'];

function getAuthorizationHeader(getAuthToken, useBearerPrefix) {
  const token = getAuthToken();
  if (!token) {
    return '';
  }
  return useBearerPrefix ? `Bearer ${token}` : token;
}

function shouldSkipAuthRedirect(url) {
  return LOGIN_URLS.includes(url);
}

const fetchModel = {
  redirectToLogin() {
    cookieModel.removeCookie('ticketlab_access');
    cookieModel.removeCookie('ticketlab_staff_access');
    authModel.clearUserType();

    const baseUrl = getBaseUrl();
    window.location.href = baseUrl + '/login';
  },

  handleAuthFailure(status, body, skipAuthRedirect) {
    if (skipAuthRedirect) {
      return false;
    }

    if (!apiErrorModel.isAuthFailure(status, body)) {
      return false;
    }

    fetchModel.redirectToLogin();
    return true;
  },

  postRequest(url, postBody, callback, options) {
    const requestId = apiErrorModel.createRequestId();
    const fetchUrl = process.env.REACT_APP_API_URL + url;
    const skipAuthRedirect = shouldSkipAuthRedirect(url);
    const authorization = getAuthorizationHeader(
      options.getAuthToken,
      options.useBearerPrefix
    );
    const hadAuthorization = Boolean(authorization);

    const headers = {
      'Content-Type': 'application/json',
      'X-Request-Id': requestId,
    };

    if (authorization) {
      headers.Authorization = authorization;
    }

    fetch(fetchUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(postBody),
    })
      .then((response) => {
        return response
          .json()
          .then((body) => ({
            response,
            body,
          }))
          .catch(() => ({
            response,
            body: null,
            parseFailed: true,
          }));
      })
      .then(({ response, body, parseFailed }) => {
        if (fetchModel.handleAuthFailure(response.status, body, skipAuthRedirect)) {
          return Promise.reject(new Error('Authentication error - redirecting to login'));
        }

        if (parseFailed) {
          callback(apiErrorModel.wrapError(apiErrorModel.normalizeParseError(requestId)));
          return;
        }

        if (!response.ok) {
          callback(
            apiErrorModel.wrapError(
              apiErrorModel.normalizeHttpError(response.status, body, requestId)
            )
          );
          return;
        }

        if (apiErrorModel.isApiFailureBody(body)) {
          callback(
            apiErrorModel.wrapError(
              apiErrorModel.normalizeApiFailureBody(body, requestId)
            )
          );
          return;
        }

        callback(body);
      })
      .catch((error) => {
        if (error?.message?.includes('Authentication error')) {
          return;
        }

        if (hadAuthorization && !skipAuthRedirect) {
          fetchModel.redirectToLogin();
          return;
        }

        callback(
          apiErrorModel.wrapError(
            apiErrorModel.normalizeNetworkError(error, requestId)
          )
        );
      });
  },

  post(url, postBody, callback) {
    const skipAuthHeader = shouldSkipAuthRedirect(url);
    fetchModel.postRequest(url, postBody, callback, {
      getAuthToken: skipAuthHeader
        ? () => ''
        : () => cookieModel.getCookie('ticketlab_access'),
      useBearerPrefix: true,
    });
  },

  postStaff(url, postBody, callback) {
    fetchModel.postRequest(url, postBody, callback, {
      getAuthToken: () => cookieModel.getCookie('ticketlab_staff_access'),
      useBearerPrefix: false,
    });
  },
};

export default fetchModel;
